import type { Size } from '@ikegps/core-api';

/**
 * This size defines the dimensions currently produced by IKE Field captures.
 *
 * NOTE: Image dimensions should be read directly from images. Use this constant only when necessary.
 */
export const DEFAULT_CAPTURE_SIZE = { width: 2836, height: 3781 } as const satisfies Size;
